import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: function (resolve) {
        require(['@/components/index'], resolve)
      },
      children: [
        {
          path: '/',
          name: 'guideList',
          components: {
            check: function (resolve) {
              require(['@/components/pullDownUp'], resolve)
            },
            login: function (resolve) {
              require(['@/components/guideList'], resolve)
            }
          }
        },
        {
          path: '/deal',
          name: 'deal',
          components: {
            check: function (resolve) {
              require(['@/components/deal'], resolve)
            },
            login: function (resolve) {
              require(['@/components/guideList'], resolve)
            },
          }
        },
        {
          path: '/comment',
          name: 'comment',
          components: {
            check: function (resolve) {
              require(['@/components/comment'], resolve)
            },
            login: function (resolve) {
              require(['@/components/guideList'], resolve)
            },
          }
        },
        {
          path: '/modifyPhone',
          name: 'modifyPhone',
          components: {
            check: function (resolve) {
              require(['@/components/pullDownUp'], resolve)
            },
            login: function (resolve) {
              require(['@/components/modifyPhone'], resolve)
            }
          }
        }, {
          path: '/modifyPassword',
          name: 'modifyPassword',
          components: {
            check: function (resolve) {
              require(['@/components/pullDownUp'], resolve)
            },
            login: function (resolve) {
              require(['@/components/modifyPassword'], resolve)
            }
          }
        }, {
          path: '/modifyMine',
          name: 'modifyMine',
          components: {
            check: function (resolve) {
              require(['@/components/pullDownUp'], resolve)
            },
            login: function (resolve) {
              require(['@/components/modifyMine'], resolve)
            }
          }
        }, {
          path: '/modifyRealMine',
          name: 'modifyRealMine',
          components: {
            check: function (resolve) {
              require(['@/components/pullDownUp'], resolve)
            },
            login: function (resolve) {
              require(['@/components/modifRealMine'], resolve)
            }
          }
        },{
          path: '/cancelAccount',
          name: 'cancelAccount',
          components: {
            check: function (resolve) {
              require(['@/components/pullDownUp'], resolve)
            },
            login: function (resolve) {
              require(['@/components/cancelAccount'], resolve)
            }
          }
        }
      ]
    }, {
      path: '/response',
      name: 'response',
      component: function (resolve) {
        require(['@/components/response'], resolve)
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js